import { OpenAPI } from '@/api/management/requests';
import { CancelablePromise } from '@/api/management/requests/core/CancelablePromise';
import { request as __request } from '@/api/management/requests/core/request';

export type TotalSeaType = 'HEIGHT' | 'PERIOD';

export type TugOperationsConfiguration = {
  id?: number;
  organisationId?: string;
  label?: string | null;
  abbr?: string | null;
  description?: string | null;
  thresholdColor?: string | null;
  thresholdValue?: number | null;
  seaType?: TotalSeaType;
};

export function getTugOperationsConfiguration(organisationId: string): CancelablePromise<TugOperationsConfiguration[]> {
  return __request(OpenAPI, {
    method: 'GET',
    url: '/organisations/{organisationId}/tug-operations',
    path: {
      organisationId,
    },
    errors: {
      404: 'Not Found',
    },
  });
}

export function saveTugOperationsConfiguration(
  organisationId: string,
  requestBody: TugOperationsConfiguration[]
): CancelablePromise<TugOperationsConfiguration[]> {
  return __request(OpenAPI, {
    method: 'POST',
    url: '/organisations/{organisationId}/tug-operations',
    path: {
      organisationId,
    },
    body: requestBody,
    mediaType: 'application/json',
  });
}
